export const postcodeFormat = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/i

export const isValidPostcode = (s: string) => {
    return s && postcodeFormat.test(s.trim().toUpperCase())
}

